import cn from "classnames";
import { Loader } from "../loader";
import styles from "./chat-loader.module.scss";

type Props = {
  wrapperClassName?: string;
  className?: string;
};

export const ChatLoader = ({ className, wrapperClassName }: Props) => (
  <div className={cn(styles["loader-wrapper"], wrapperClassName)}>
    <Loader className={className} />
  </div>
);
